import PageGlow from "../components/PageGlow";
import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import Seo from "../components/Seo";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err, "Could not send your message"));
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20" data-testid="contact-page">
      <PageGlow />
      <Seo title="Contact Us | HiredToday" description="Questions about posting a job or your account? Contact the HiredToday team." path="/contact" />
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Contact</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black text-zinc-950">Get in touch.</h1>
      <p className="mt-4 text-zinc-600 leading-relaxed">
        Questions about a listing, a payment or your account? We reply within one working day.
      </p>
      <p className="mt-3 text-sm text-zinc-600">
        Email us at{" "}
        <a href="mailto:office@hiredtoday.co.uk" data-testid="contact-email-link" className="text-blue-700 font-medium hover:text-blue-900">
          office@hiredtoday.co.uk
        </a>
      </p>

      {sent ? (
        <div className="mt-10 border border-green-200 bg-green-50 rounded-md p-8" data-testid="contact-sent">
          <h2 className="font-display text-xl font-bold text-green-900">Message received.</h2>
          <p className="mt-2 text-sm text-green-800">We'll come back to you as soon as we can.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <div>
              <label className="text-sm font-medium text-zinc-700 block mb-1.5">Your name *</label>
              <input required data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full h-12 px-4 border border-zinc-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-600" />
            </div>
            <div>
              <label className="text-sm font-medium text-zinc-700 block mb-1.5">Email *</label>
              <input required type="email" data-testid="contact-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full h-12 px-4 border border-zinc-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-600" />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-zinc-700 block mb-1.5">Message *</label>
            <textarea required rows={6} data-testid="contact-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full px-4 py-3 border border-zinc-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 resize-y" />
          </div>
          <button type="submit" disabled={sending} data-testid="contact-submit"
            className="h-12 px-8 bg-zinc-950 text-white text-sm font-semibold rounded-md hover:bg-zinc-800 transition-colors duration-200 disabled:opacity-50">
            {sending ? "Sending…" : "Send message"}
          </button>
        </form>
      )}
    </main>
  );
}
